import React from 'react';
import styles from './RightHeaderMenu.module.css';

/** One menu row: an icon tile, the label, and optional trailing content such as a count. */
const MenuRow = ({ icon, label, extra }) => (
    <span className={styles.row}>
        <span className={styles.iconBox}>{icon}</span>
        <span className={styles.label}>{label}</span>
        {extra}
    </span>
);

export default MenuRow;
